/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { bem } from "../shared/BEM";

/**
 * Component props
 */
export interface IButtonProps {
	icon?: string;
	label?: string;
	title?: string;
	style?: "default"|"primary";
	disabled?: boolean;
	onClick?: () => void;
	renderCustom?: () => React.ReactElement;
}

/**
 * Button component
 *
 * @param props Component props
 */
export function Button(props: IButtonProps) {

	const mods = [
		"style-" + (props.style || "default")
	];

	if (props.icon && !props.label) {
		mods.push("icon-only");
	}

	const style = bem("button").mod(mods);

	return <button className={style.className()} title={props.title} disabled={props.disabled} onClick={props.onClick}>
		{ props.icon ? <i className={`mdi mdi-${props.icon}`} /> : null }
		{ props.label ? <span className={style.el("label").className()}>{props.label}</span> : null }
		{ props.renderCustom ? props.renderCustom() : null }
	</button>;

}
